import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios, { API_BASE_URL } from "../../../components/api/axios";
import ImageLoader from "../../common/ImageLoader";
import "./Team.css";

const Team = () => {
  const [members, setMembers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const res = await axios.get("/team");
      setMembers(res.data.reverse());
    } catch (err) {
      console.error("Error fetching team members:", err);
    }
  };

  const handleViewFullTeam = () => {
    navigate("/ourteam");
  };

  return (
    <section className="team-section" id="team">
      <div className="team-container">
        <div className="section-header">
          <span className="section-tag">✦ LEADERSHIP &amp; CORE TEAM</span>
          <h2 className="section-main-title">Meet Our Team</h2>
          <p className="section-description">
            The passionate minds driving technical innovation and community
            empowerment at DIET ACM.
          </p>
        </div>

        <div className="team-grid">
          {members.map((member) => (
            <div className="team-card glass-panel" key={member.id}>
              <div className="team-photo-wrapper">
                <ImageLoader
                  src={`${API_BASE_URL}/${member.imagePath}`}
                  alt={member.name}
                  className="team-photo"
                />
                <div className="photo-ring-glow"></div>
              </div>
              <div className="team-info">
                <h3 className="team-member-name">{member.name}</h3>
                <span className="team-member-role">{member.title}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="view-full-wrapper">
          <button className="btn-view-full" onClick={handleViewFullTeam}>
            <span>View Full Team &amp; History</span>
            <i className="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Team;